import { render, staticRenderFns } from "./BoothComponent.vue?vue&type=template&id=6f087c47&scoped=true&"
import script from "./BoothComponent.vue?vue&type=script&lang=js&"
export * from "./BoothComponent.vue?vue&type=script&lang=js&"
import style0 from "./BoothComponent.vue?vue&type=style&index=0&id=6f087c47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f087c47",
  null
  
)

export default component.exports